/* eslint-disable */
import { Slider } from '@miblanchard/react-native-slider';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Dimensions, View } from 'react-native';
import { Text } from '@/components/Text';

// styles
import styles from './settingsStyles';
import { PressableNeolexon } from '@/components/PressableNeolexon';

const WARNING_STATE_KEYS = ['Verstehen', 'Lesen'];

const SCREEN_WIDTH = Dimensions.get('window').height;

export const Writing = forwardRef(
  (
    {
      stateKey,
      UI,
      defaultValues,
      outerValue,
      outerValueName,
      changeWarning,
      warningIndex,
    },
    ref,
  ) => {
    // variables
    const { title, subTitles, variableTitles } = UI;
    const hasVariableTitles = variableTitles != undefined;

    // state
    const [state, setState] = useState({ ...defaultValues });
    // For now is used only if the setType prop is = textset
    const [outerState, setOuterState] = useState({
      [outerValueName]: outerValue,
    });

    // functions
    const handleStateChange = (name, value) => {
      return () => {
        setState((prevState) => ({ ...prevState, [name]: value }));
      };
    };

    const handleOuterStateChange = (name, value) => {
      return () => {
        setOuterState((prevState) => ({ ...prevState, [name]: value }));
      };
    };

    const drawVariableTitles = (variableData) => {
      return (
        <View>
          <Text style={styles.subTitle}>{variableData.title}</Text>
          <View style={styles.row}>
            {variableData.data.map((value) => {
              const isActive = value === state.value;
              return (
                <PressableNeolexon
                  style={
                    isActive ? [styles.radio, styles.radioActive] : styles.radio
                  }
                  key={value}
                  onPress={handleStateChange(
                    variableData.globalStateName,
                    value,
                  )}
                >
                  <Text
                    style={
                      isActive
                        ? [styles.radioText, styles.radioActiveText]
                        : styles.radioText
                    }
                  >
                    {value}
                  </Text>
                </PressableNeolexon>
              );
            })}
          </View>
        </View>
      );
    };

    const getState = () => ({
      state,
      stateKey,
      outerValue: outerState[outerValueName],
      outerName: outerValueName,
    });

    useImperativeHandle(ref, () => {
      return {
        getState,
      };
    }, [state, outerState]);

    useEffect(() => {
      if (WARNING_STATE_KEYS.includes(stateKey)) {
        if (state.setting === 'fromset') {
          changeWarning(warningIndex, 'add');
        } else {
          changeWarning(warningIndex, null);
        }
      }
    }, [state.setting]);

    return (
      <>
        <Text style={styles.title}>{title}</Text>
        {subTitles.map((subTitle) => {
          return (
            <View key={subTitle.title}>
              <Text style={styles.subTitle}>{subTitle.title}</Text>
              <View style={styles.row}>
                {!subTitle.isNotRadio ? (
                  subTitle.data.map((eachData) => {
                    const hasOuterState =
                      subTitle.globalStateName == 'audioSpeedSetting';
                    let isActive = null;
                    if (hasOuterState) {
                      isActive = eachData.value === outerState[outerValueName];
                    } else {
                      isActive =
                        eachData.value === state[subTitle.globalStateName];
                    }
                    return (
                      <PressableNeolexon
                        style={
                          isActive
                            ? [styles.radio, styles.radioActive]
                            : styles.radio
                        }
                        onPress={
                          hasOuterState
                            ? handleOuterStateChange(
                                outerValueName,
                                eachData.value,
                              )
                            : handleStateChange(
                                subTitle.globalStateName,
                                eachData.value,
                              )
                        }
                        key={eachData.value}
                      >
                        <Text
                          style={
                            isActive
                              ? [styles.radioText, styles.radioActiveText]
                              : styles.radioText
                          }
                        >
                          {eachData.label}
                        </Text>
                      </PressableNeolexon>
                    );
                  })
                ) : (
                  <View
                    style={[
                      styles.row,
                      { width: '100%', alignItems: 'center' },
                    ]}
                  >
                    <Text
                      style={[
                        styles.subTitle,
                        state.setting === 'norecord' && { color: '#aaaa' },
                      ]}
                    >
                      {subTitle.sliderLabel}
                    </Text>
                    <Slider
                      value={state.value}
                      containerStyle={{
                        width: SCREEN_WIDTH * 0.6,
                        height: 50,
                        marginHorizontal: 10,
                      }}
                      step={1}
                      minimumValue={subTitle.data[0]}
                      maximumValue={subTitle.data[1]}
                      onValueChange={(newValue) => {
                        handleStateChange(
                          subTitle.globalStateName,
                          newValue?.[0] || subTitle.data[0],
                        )();
                      }}
                      disabled={state.setting === 'norecord'}
                      thumbTintColor={
                        state.setting === 'norecord' ? '#aaaa' : '#50BF92'
                      }
                      minimumTrackTintColor={
                        state.setting === 'norecord' ? '#aaaa' : '#50BF92'
                      }
                    />
                    <Text
                      style={[
                        styles.subTitle,
                        state.setting === 'norecord' && { color: '#aaaa' },
                      ]}
                    >
                      {state.value}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          );
        })}
        {hasVariableTitles
          ? drawVariableTitles(variableTitles[state.setting])
          : null}
      </>
    );
  },
);
Writing.displayName = 'Writing';
